export default "__VITE_ASSET__DyFmIcw1__";